import React,{ useState } from "react";
import { Link } from "react-router-dom";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@material-ui/core";


import style from "./style";
const useStyles = makeStyles(style);

const OneProjectCard = (project) => {
  const classes = useStyles();

  const [numState,setNumState] = useState(false);

  return <Box
    style={{
      transform: `translateY(${window.innerWidth > 600 && (project.id - 1) % 2 !== 0 ? 100 : 0
        }px)`,
    }}
    className={`${classes.cardLink} ${classes.cardWrapper} hover-detect`}

    onMouseEnter={()=>{setNumState(true)}}
    onMouseLeave={()=>{setNumState(false)}}
  >
    <Link to={`/projects/${project.id}`} className="hover-detect">
      <Card data-aos="fade-in" data-aos-delay="100" className={classes.card}>
        <CardActionArea>
          {/* <div className={classes.imageOverlay}></div> */}
          <CardMedia
            className={classes.media}
            image={project.image}
            title="Project 1"
            alt="Card Media Image"
            style={{ backgroundSize: "cover" }}
          />
        </CardActionArea>
        <CardContent style={{ padding: "20px 0" }}>
          <Typography data-aos="fade-in" data-aos-delay="100" gutterBottom variant="h5" component="h4">
            {project.title}
          </Typography>
          <Typography
            data-aos="fade-in" data-aos-delay="200"
            className={classes.tagName}
            variant="body2"
            color="textSecondary"
            component="p"
          >
            {project.tag}
          </Typography>
        </CardContent>
      </Card>
      <Typography
        variant="h2"
        className={`${numState ? classes.cardNumSolid : classes.cardNum}  ${classes.title} ${classes.num}`}
      >
        {(project.id < 10 ? "0" : "") + project.id}
      </Typography>
    </Link>
  </Box>
}

const ProjectCards = ({ data }) => {
  return (
    <>
      {data.map((project) => OneProjectCard(project))}
    </>
  );
};

export default ProjectCards;
